export default __webpack_public_path__ + "static/media/EM1350.34I-36495_-21467_0.3e362877.jpg";